// Product card wishlist heart (snippets/quick-add.liquid).
// Wishlisted product handles are kept in this browser's localStorage; every heart for the same
// product stays in sync across cards on the page and across open tabs.
const STORAGE_KEY = 'alwesal-wishlist';
const CHANGE_EVENT = 'wishlist:change';

const readStorage = () => {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return Array.isArray(value) ? value : [];
  } catch (error) {
    return [];
  }
};

// Kept in memory as well so the heart still toggles when storage is unavailable (e.g. private mode).
let wishlist = new Set(readStorage());

const saveWishlist = () => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...wishlist]));
  } catch (error) {
    // Storage blocked or full: the in-memory state still drives the UI for this page view.
  }
};

window.addEventListener('storage', (event) => {
  if (event.key !== STORAGE_KEY) return;
  wishlist = new Set(readStorage());
  document.dispatchEvent(new CustomEvent(CHANGE_EVENT));
});

class WishlistButton extends HTMLElement {
  #controller;

  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.button.addEventListener('click', this.toggle.bind(this), { signal });
    document.addEventListener(CHANGE_EVENT, this.render.bind(this), { signal });
    this.render();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  get handle() {
    return this.getAttribute('handle');
  }

  toggle(event) {
    event.preventDefault();
    if (!this.handle) return;
    if (wishlist.has(this.handle)) {
      wishlist.delete(this.handle);
    } else {
      wishlist.add(this.handle);
    }
    saveWishlist();
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { handle: this.handle, active: wishlist.has(this.handle) } }));
  }

  render() {
    const active = wishlist.has(this.handle);
    const label = active ? this.dataset.labelRemove : this.dataset.labelAdd;
    this.button.setAttribute('aria-pressed', String(active));
    if (label) {
      this.button.setAttribute('aria-label', label);
      this.button.setAttribute('data-tooltip', label);
    }
  }
}

if (!customElements.get('hdt-wishlist-btn')) customElements.define('hdt-wishlist-btn', WishlistButton);
